<form nz-form [formGroup]="billingFilterForm">
    <div nz-row gutter="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%">

        <div nz-col *ngIf="billingFilterForm.controls['timeframe']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Timeframe'">
                    <ppl-dropdown-select formControlName="timeframe" class="filters" id="timeframe" [options]="loopback"
                        [optionLabel]="'label'" [optionValue]="'value'" placeholder="Timeframe" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['batchDate']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Batch date'">
                    <ppl-dropdown-select formControlName="batchDate" class="filters" id="batchDate"
                        [options]="batchDates" [optionLabel]="'label'" [optionValue]="'value'"
                        placeholder="Batch Date" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['status']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a status'">
                    <ppl-dropdown-select formControlName="status" class="filters" id="status" [options]="statusList"
                        [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" placeholder="Status" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['claimStatus']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a claim status'">
                    <ppl-dropdown-select formControlName="claimStatus" class="filters" id="claimStatus"
                        [options]="claimStatusList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueName'"
                        placeholder="Claim Status" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['statusCode']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="8"
            [nzXl]="8" [nzXXl]="6" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a claim status code'">
                    <ppl-dropdown-select formControlName="statusCode" class="filters" id="statusCode"
                        [options]="statusCodeList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                        placeholder="Claim Status Code" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['memberId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Member ID'">
                    <input placeholder="Member ID" nz-input (input)="onInput($event, 'memberId')"
                        formControlName="memberId" id="memberId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['participantPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Consumer PPL ID'">
                    <input placeholder="Consumer PPL ID" nz-input (input)="onInput($event, 'participantPplId')"
                        formControlName="participantPplId" id="participantPplId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['providerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter PA PPL ID'">
                    <input placeholder="PA PPL ID" nz-input (input)="onInput($event, 'providerPplId')"
                        formControlName="providerPplId" id="providerPplId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['pplIcn']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a PPL ICN'">
                    <input placeholder="PPL ICN" nz-input (input)="onInput($event, 'pplIcn')" formControlName="pplIcn"
                        id="pplIcn" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['paymentNumber']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Payment Number'">
                    <input placeholder="Payment Number" nz-input (input)="onInput($event, 'paymentNumber')"
                        formControlName="paymentNumber" id="paymentNumber" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['extIcn']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter an External ICN'">
                    <input placeholder="External ICN" nz-input (input)="onInput($event, 'extIcn')"
                        formControlName="extIcn" id="extIcn" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['pplBatchId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a PPL Batch ID'">
                    <input placeholder="PPL Batch ID" nz-input (input)="onInput($event, 'pplBatchId')"
                        formControlName="pplBatchId" id="pplBatchId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['authNumber']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Authorization Number'">
                    <input placeholder="Authorization Number" nz-input (input)="onInput($event, 'authNumber')"
                        formControlName="authNumber" id="authNumber" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['medicaidCin']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Medicaid CIN'">
                    <input placeholder="Medicaid CIN" nz-input (input)="onInput($event, 'medicaidCin')"
                        formControlName="medicaidCin" id="medicaidCin" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['mcoName']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control
                    [nzErrorTip]="'Please enter the ' + (billingPageName === 'pmpmClaims' ? 'Payer' : 'MCO') + ' Name'">
                    <ppl-dropdown-select formControlName="mcoName" class="filters" id="mcoName" [options]="mcoEntries"
                        [optionLabel]="'orgName'" [optionValue]="'orgName'"
                        [placeholder]="(billingPageName === 'pmpmClaims' ? 'Payer' : 'MCO') + ' Name'" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['serviceCode']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a Service Code'">
                    <input nz-input formControlName="serviceCode" id="serviceCode" placeholder="Service Code" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['modifier']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a Modifier Code'">
                    <input nz-input formControlName="modifier" id="modifier" placeholder="Modifier Code" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['timesheetId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a Timesheet Id'">
                    <input placeholder="Timesheet Id" nz-input (input)="onInput($event, 'timesheetId')"
                        formControlName="timesheetId" id="timesheetId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['pmpm']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
            [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a value'">
                    <ppl-dropdown-select formControlName="pmpm" class="filters" id="pmpm" [options]="radioOptions"
                        [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" placeholder="PMPM" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['year']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
            [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a value'">
                    <ppl-dropdown-select formControlName="year" class="filters" id="year" [options]="years"
                        [optionLabel]="'label'" [optionValue]="'value'" placeholder="Year" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['month']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
            [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a value'">
                    <ppl-dropdown-select formControlName="month" class="filters" id="month" [options]="months"
                        [optionLabel]="'name'" [optionValue]="'code'" placeholder="Month" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['fileType']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter the MCO Name'">
                    <ppl-dropdown-select formControlName="fileType" class="filters" id="fileType"
                        [options]="fileTypeList" [optionLabel]="'label'" [optionValue]="'value'"
                        placeholder="File Type" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['fileName']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a File name'">
                    <input placeholder="File Name" nz-input (input)="onInput($event, 'fileName')"
                        formControlName="fileName" id="fileName" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['batchName']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a Batch name'">
                    <input placeholder="Batch Name" nz-input (input)="onInput($event, 'batchName')"
                        formControlName="batchName" id="batchName" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['runId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
            [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a Run Id'">
                    <input placeholder="Run Id" nz-input (input)="onInput($event, 'runId')" formControlName="runId"
                        id="runId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['eventCode']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="8"
            [nzXl]="8" [nzXXl]="6" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a value'">
                    <ppl-dropdown-select formControlName="eventCode" class="filters" id="eventCode"
                        [options]="eventCodeOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                        placeholder="Event Code" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['ignoreReason']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter the Ignore Reason'">
                    <ppl-dropdown-select formControlName="ignoreReason" class="filters" id="ignoreReason"
                        [options]="ignoreReasonList" [optionLabel]="'ignoreReason'" [optionValue]="'ignoreReason'"
                        placeholder="Ignore Reason" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['serviceDate']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select the Service Date'">
                    <nz-date-picker formControlName="serviceDate" [id]="'serviceDate'" style="height: 32px;"
                        [nzFormat]="'MM/dd/yyyy'" [nzPlaceHolder]="'Service Date'"></nz-date-picker>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['resub']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
            [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a value'">
                    <ppl-dropdown-select formControlName="resub" class="filters" id="resub" [options]="radioOptions"
                        [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" placeholder="Resubmitted" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['workdayRunId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a Workday Run Id'">
                    <input nz-input formControlName="workdayRunId" id="workdayRunId" placeholder="Workday Run Id" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col *ngIf="billingFilterForm.controls['payerId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a Payer Id'">
                    <input nz-input formControlName="payerId" id="payerId" placeholder="Payer Id" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col *ngIf="billingFilterForm.controls['enrichedBatchId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a Enriched Batch Id'">
                    <input nz-input formControlName="enrichedBatchId" id="enrichedBatchId"
                        placeholder="Enriched Batch Id" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['workdaySales']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Workday Sales'">
                    <input placeholder="Workday Sales" nz-input (input)="onInput($event, 'workdaySales')"
                        formControlName="workdaySales" id="workdaySales" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col [nzSpan]="24" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="text-align: right; margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <ppl-button label="Search" icon="fa fa-filter" style="margin-top: -2px;" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="search()"></ppl-button>
            </nz-form-item>
        </div>

    </div>
</form>